import { http } from "@/utils/http";
export const getCommunityList = (params) => {
  // 获取社群列表
  return http({ url: `/1/communities/`, method: "get", params: params });
};
export const communitiesDetail = (params) => {
  // 获取社群详情
  return http({ url: `/1/communities/${params.id}`, method: "get" });
};
export const comments = (params) => {
  // 留言
  return http({ url: `/1/comments`, method: "post", data: params });
};
export const delComments = (params) => {
  // 删除留言
  return http({ url: `/1/comments/${params}`, method: "patch", data: {status:0} });
};
export const getCommentsList = (params) => {
  // 获取留言
  return http({ url: `/1/comments`, method: "get", params: params });
};
export const publishArticle = (params) => {
  // 发表文章
  return http({ url: `/1/communities/`, method: "post", data: params });
};
export const delArticle = (params) => {
  // 删除文章
  return http({
    url: `/1/communities/${params}`,
    method: "patch",
    data: { status: 0 },
  });
};
